import { FC } from 'react';

import Button from '../../buttons/Button';
import { TextField } from '../fields';

import { RedeemCouponWrapper } from './Wrapper';

export type RedeemCouponProps = { onRedeem(): void; placeholder?: string };

const RedeemCoupon: FC<RedeemCouponProps> = ({ placeholder = 'Enter your coupon code here', onRedeem }) => (
  <RedeemCouponWrapper>
    <TextField
      name="coupon"
      type="text"
      placeholder={placeholder}
      labelVariant="static-above-dark-uppercase"
      inputVariant="simple-small"
    />
    <Button type="submit" variant="white-text-field" size="medium" onClick={onRedeem}>
      Redeem
    </Button>
  </RedeemCouponWrapper>
);

export default RedeemCoupon;
